// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.container-login .jumbotron {\n  background-color: #FFF;\n  margin-top: 30px;\n}\n\n.container-login .jumbotron .loading {\n  color: #00AEEF;\n}\n\n.container-login .jumbotron-restricted p {\n  font-size: 14px;\n}\n", ""]);
// Exports
module.exports = exports;
